const LABELS = {
  CONFIRM: 'Confirmar',
  CLOSE: 'Fechar'
};

export default LABELS;
